<template>
  <footer class="l-footer">
    <div class="l-footer__top">
      <ul class="l-footer__links">
        <li><router-link to="/" exact>Home</router-link></li>
        <li><router-link :to="{name: 'about'}">About Setouchi Cominca Stays</router-link></li>
        <li><router-link :to="{name: 'privacypolicy'}">Privacy Policy</router-link></li>
        <li><router-link :to="{name: 'terms'}">Terms of Use</router-link></li>
        <li><a href="https://forms.gle/U95mXdSstduTMkbRA" target="_blank">Contact Us</a></li>
      </ul>
      <!-- <div class="l-footer__content">
        <router-link to="/" class="l-footer__logo">
          <img src="../assets/img/logo/logo_main.svg" alt="SETOUCHI COMINCA STAYS">
        </router-link>
        <div>
          <ul class="l-footer__links">
            <li><router-link to="/">Home</router-link></li>
            <li><router-link :to="{name: 'about'}">About Setouchi Cominca Stays</router-link></li>
            <li><router-link :to="{name: 'privacypolicy'}">Privacy Policy</router-link></li>
          </ul>
          <dl class="l-footer__sns">
            <dt>Follow us</dt>
            <dd><a href="#" class="l-footer__icon" data-icon="facebook">Facebook</a></dd>
            <dd><a href="#" class="l-footer__icon" data-icon="youtube">YouTube</a></dd>
            <dd><a href="#" class="l-footer__icon" data-icon="instagram">Instagram</a></dd>
          </dl>
        </div>
      </div> -->
    </div>
    <div class="l-footer__bottom">
      <div>
        <ul class="l-footer__banners">
          <li>
            <a href="http://setouchitourism.or.jp/en/" target="_blank">
              <picture>
                <source srcset="../assets/img/banner/sp/logo-dmo.png" media="(max-width: 1023px)">
                <img src="../assets/img/banner/pc/logo-dmo@2x.png" alt="SETOUCHI" class="l-footer__banner" data-logo="authority">
              </picture>
            </a>
          </li>
          <li>
            <a href="https://www.setouchi-bc.co.jp/" target="_blank">
              <picture>
                <source srcset="../assets/img/banner/sp/logo-brand.png" media="(max-width: 1023px)">
                <img src="../assets/img/banner/pc/logo-brand@2x.png" alt="SETOUCHI BRAND CORPORATION" class="l-footer__banner" data-logo="corp">
              </picture>
            </a>
          </li>
          <li>
            <a href="http://setouchitrip.com/" target="_blank">
              <picture>
                <source srcset="../assets/img/banner/sp/logo-trip.png" media="(max-width: 1023px)">
                <img src="../assets/img/banner/pc/logo-trip@2x.png" alt="SETOUCHI REFRECTION TRIP" class="l-footer__banner" data-logo="trip">
              </picture>
            </a>
          </li>
          <li>
            <a href="https://setouchifinder.com/en/" target="_blank">
              <picture>
                <source srcset="../assets/img/banner/sp/logo-finder.png" media="(max-width: 1023px)">
                <img src="../assets/img/banner/pc/logo-finder@2x.png" alt="SETOUCHI Finder" class="l-footer__banner" data-logo="site">
              </picture>
            </a>
          </li>
        </ul>
        <small class="l-footer__copyright">&copy; Setouchi Brand Corporation Inc.</small>
      </div>
    </div>
  </footer>
</template>

<script>

  /**
   * Plugins
   */

  export default {
    name: 'global-footer',
    data () {
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/global-footer.vue